import { Form } from 'react-bootstrap';
import { useEffect } from 'react';

import { useAppSelector, useAppDispatch } from 'redux/store';
import ScriptEditor from '../ui/ScriptEditor';
import { getConnections } from '../../../../../../../redux/slices/lists/connectionsSlice';

const Rest = ({ state, onChange, readOnly = false }) => {
  const { body = '', path = '', method = '', connection = '' } = state.config || {};

  const methodList = ['GET', 'POST', 'PUT', 'DELETE'];

  const dispatch = useAppDispatch();
  const { connections = [] } = useAppSelector((state) => state?.listOfConnections);

  useEffect(() => {
    const fetchConnections = async () => {
      try {
        await dispatch(getConnections('rest'));
      } catch (error) {
        console.error('Error fetching connections:', error);
      }
    };
    fetchConnections();
  }, []);

  return (
    <>
      <Form.Group className="mb-2 w-full" controlId="formNode-method">
        <Form.Label>Method</Form.Label>
        <Form.Select aria-label="method-select" name="method" value={method} onChange={(e) => onChange(e, true)} disabled={readOnly}>
          <option>Select method</option>
          {methodList.map((method, index) => {
            return (
              <option key={index} value={method}>
                {method}
              </option>
            );
          })}
        </Form.Select>
      </Form.Group>
      <Form.Group className="mb-2 w-full" controlId="formNode-connection">
        <Form.Label>Connection</Form.Label>
        <Form.Select aria-label="connection-select" name="connection" value={connection} onChange={(e) => onChange(e, true)} disabled={readOnly}>
          <option>Select connection</option>
          {connections &&
            connections.map((connection, index) => {
              const { connection_id, connection_name } = connection;

              return (
                <option key={index} value={connection_id}>
                  {connection_name}
                </option>
              );
            })}
        </Form.Select>
      </Form.Group>
      <Form.Group className="mb-2 w-full" controlId="formNode-path">
        <Form.Label>Path</Form.Label>
        <Form.Control type="text" name="path" value={path} onChange={(e) => onChange(e, true)} disabled={readOnly} />
      </Form.Group>

      <ScriptEditor
        label="Body"
        controlId="formNode-body"
        name="body"
        value={body}
        language="json"
        onChange={(e) => onChange(e, true)}
        readOnly={readOnly}
        aria-label="Body editor"
      />
    </>
  );
};

export default Rest;
